export default __webpack_public_path__ + "static/media/myfinalwishes_11.612c1f77.png";